import avatarAmit from '../assets/avatar_amit.png';
import avatarPriya from '../assets/avatar_priya.png';
import avatarRahul from '../assets/avatar_rahul.png';

const testimonials = [
  {
    name: "Amit Sharma",
    amount: "₹45,000 LOAN",
    avatar: avatarAmit,
    quote: "The process was genuinely under 10 minutes. I needed urgent funds for a medical bill, and ToofanLoan delivered before my coffee was cold."
  },
  {
    name: "Priya Verma",
    amount: "₹15,000 LOAN",
    avatar: avatarPriya,
    quote: "Transparent and fast. I love how they explain every charge upfront. No surprises, just solid financial support when you need it most."
  },
  {
    name: "Rahul Gupta",
    amount: "₹28,000 LOAN",
    avatar: avatarRahul,
    quote: "I had a slightly lower credit score, but ToofanLoan approved me within minutes. They are helping me build my credit history back up."
  }
];

const Testimonials = () => {
  return (
    <section className="w-full py-16 md:py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Main Heading as per reference image */}
        <div className="max-w-4xl mx-auto text-center mb-16 md:mb-20">
          <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-serif text-black leading-[1.2] font-medium tracking-tight">
            "ToofanLoan saved my life during a crunch."
          </h2>
        </div>

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-12">
          {testimonials.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 md:p-10 border-l-[4px] border-[var(--primary)] shadow-[0_4px_20px_rgba(0,0,0,0.03)] hover:shadow-[0_4px_25px_rgba(0,0,0,0.06)] transition-all duration-300 flex flex-col gap-8 h-full"
            >
              {/* Card Header with Avatar and User Info */}
              <div className="flex items-center gap-5">
                <div className="w-16 h-16 rounded-[14px] overflow-hidden shadow-sm flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex flex-col gap-1">
                  <h3 className="text-[17px] font-bold text-[var(--text-primary)] font-sans leading-none">
                    {item.name}
                  </h3>
                  <p className="text-[var(--primary)] text-[10px] md:text-[11px] font-black tracking-[0.1em] uppercase font-sans">
                    {item.amount}
                  </p>
                </div>
              </div>

              {/* Quote Body */}
              <div className="relative">
                <p className="text-[var(--text-gray)] text-[15px] md:text-[16px] leading-[1.8] font-sans opacity-[0.85] italic relative ">
                  "{item.quote}"
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
